import { createFileRoute } from '@tanstack/react-router';
import { PortalCirculars } from '@/features/circulars/PortalCirculars';

/* Le circolari ricevute dal referente del portale (task 2055). */
export const Route = createFileRoute('/_portal/portal/circulars')({
  component: PortalCircularsRoute,
  validateSearch: (s: Record<string, unknown>): { open?: string } =>
    (typeof s.open === 'string' && s.open ? { open: s.open } : {}),
});

function PortalCircularsRoute() {
  return <PortalCirculars openId={Route.useSearch().open ?? null} />;
}
